import { render, staticRenderFns } from "./ArticleArea.vue?vue&type=template&id=4783f8f6&scoped=true"
import script from "./ArticleArea.vue?vue&type=script&lang=js"
export * from "./ArticleArea.vue?vue&type=script&lang=js"
import style0 from "./ArticleArea.vue?vue&type=style&index=0&id=4783f8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783f8f6",
  null
  
)

export default component.exports